import IconButton from './IconButton';
import { ReactComponent as ArrowBackIcon } from '../../../assets/icons/arrow_back.svg';

import './back-button.css';

interface BackButtonProps {
    onClick: () => void;
}

/**
 * Back button that shows up in the top left corner of the page.
 */
function BackButton(props: BackButtonProps) {
    const { onClick } = props;

    return (
        <div className="back-button">
            <IconButton IconComponent={ArrowBackIcon} onClick={onClick} />
        </div>
    );
}

export default BackButton;
